<template>
  <div>
    <br/>
    <table style="width: 100%">
      <tr>
        <td style="width: 70%">
          <h5 class="pageTitle">Défi de ta fenêtre</h5>
          <br/><br/>

          <h2 class="pageSubtitle2">Présentation</h2>
          <p>
            Le<span style="color:#b1661b;font-weight:bold;"
          > Défi de ta fenêtre</span
          >
            se veut un défi facile, lancé à tous les membres pour occuper les
            longues journées d'hiver le tout, sans même se geler les pieds ou le
            bout du nez !
          </p>

          <p>
            Le Défi consiste à faire l'observation du plus grand nombre possible d'espèces d'oiseaux et ce, à partir
            d'une seule fenêtre. Le membre choisit une fenêtre de sa résidence à partir de laquelle il notera toutes ses
            observations du 1<sup>er</sup> décembre jusqu'au dernier jour de février. L'activité se termine le deuxième vendredi de mars par une soirée de clôture ouverte à tous les membres.
          </p>

          <h2 class="pageSubtitle2">Règles de l'activité</h2>
          <ul>
            <li>
              <p>
                Être membre du Club des ornithologues de Québec (COQ).
              </p>
            </li>
            <li>
              <p>
                Choisir
                <span style="color:#b1661b;font-weight:bold;">une</span> fenêtre
                pour réaliser
                <span style="color:#b1661b;font-weight:bold;">toutes</span> vos
                observations. À certaines occasions, il est permis d'ouvrir la
                fenêtre et de se pencher vers l'extérieur mais
                <span style="color:#b1661b;font-weight:bold;">
                  un pas dehors, disqualifierait l'oiseau ainsi observé!
                </span>
              </p>
            </li>
            <li>
              <p>
                Les <span style="color:#b1661b;font-weight:bold;">couples</span> peuvent s’inscrire ensemble (une
                fenêtre) ou séparément (en choisissant deux fenêtres distinctes).
              </p>
            </li>
            <li>
              <p>
                Notez vos observations : caractéristiques particulières, nombre
                d'espèces, fréquence des visites de la même espèce, le plus
                petit et le plus gros visiteur... Seuls les oiseaux
                <span style="color:#b1661b;font-weight:bold;">vus</span> de la
                même fenêtre feront partie de votre liste.
              </p>
            </li>
            
            <li>
              <p>
                Transmettre vos données mensuellement, selon les directives que vous recevrez.
              </p>
            </li>
            <li>
              <p>
                Nous suggérons, sans obligation, d’inscrire toutes vos observations dans <span
                  style="color:#b1661b;font-weight:bold;"><a href=" https://ebird.org/home" target="_blank">eBird</a></span>.
              </p>
            </li>
            <li>
              <p>
                Nous suggérons aussi de participer au <a href=" https://www.facebook.com/groups/3034834729983278" target="_blank">groupe Facebook</a> de l’activité (réservé aux participants).
              </p>
            </li>
          </ul>

          <h2 class="pageSubtitle2">Inscription</h2>
          <p>
            Les participants et participantes devront s’inscrire <span style="color:#b1661b;font-weight:bold;"
          >par courriel</span
          > à l'adresse suivante : <a href="mailto:romill@videotron.ca ">romill@videotron.ca</a>, entre le 15 novembre et le 15
            décembre.
          </p>

          <br/>

          <!-- <b-row style="margin-top: 20px; margin-bottom: 40px;">
            <b-col>
              <template v-if="activity && isConnected && activity.acceptRegistrations === true">
                <b-button

                    variant="primary"
                    @click="showRegisterModal"
                    style="width: 100%"
                >
                  Inscription à l'activité
                </b-button>
              </template>
              <template v-else-if="!activity || activity.acceptRegistrations === false">
                <b-button  variant="outline-secondary" style="width: 100%">
                  Les inscriptions ne sont pas encore activés
                </b-button>
              </template>
              <template v-else>
                <b-button  variant="outline-secondary" style="width: 100%">
                  Vous devez être connecté pour vous inscrire à cette activité
                </b-button>
              </template>
            </b-col>
          </b-row> -->

          <h2 class="pageSubtitle2">Comité Défi de ta fenêtre</h2>
          <p>Claude Achim, Nathalie Millette, Mélodie Paquet et Mélissande Paquet</p>
          <br/>
        </td>
        <td style="width: 30%; padding-left: 10px;">
          <br/><br/><br/><br/><br/><br/><br/><br/>
          <table id="table_comptes-rendus" style="width: 100%">
            <tr>
              <td style="width: 12%">
                <a href="/documents/ecolo-defi/compte-rendu2016-2017.pdf">
                  <img src="/images/icone_pdf.png" alt=""/>
                </a>
              </td>
              <td>
                <a
                    href="/documents/ecolo-defi/stat-global-ecolo-defi.pdf"
                    title="Liste des espèces depuis 2011-2012"
                >Liste des espèces depuis 2011-2012</a>
                <br/>&nbsp;<br/><br/>
                <a
                    href="/documents/ecolo-defi/stat-global-ecolo-defi-suite.pdf"
                    title="Liste des espèces depuis 2023-2024"
                >Liste des espèces depuis 2023-2024</a>
              </td>
            </tr>
            <template v-for="y in years">
              <table :key="y">
                <tr>
                  <td colspan="2">&nbsp;</td>
                </tr>
                <tr>
                  <td></td>
                  <td>
                    <h6 style="font-size:14px; color:#b1661b">Année {{ y }}</h6>
                  </td>
                </tr>
                <tr>
                  <td style="width: 12%">
                    <a :href="'/documents/ecolo-defi/compte-rendu' + y + '.pdf'">
                      <img src="/images/icone_pdf.png" alt=""/>
                    </a>
                  </td>
                  <td>
                    <a :href="'/documents/ecolo-defi/compte-rendu' + y + '.pdf'">
                      Rapport {{ y }}
                    </a>
                    <div class="clear"></div>
                    <template v-if="y !== '2023-2024-Facebook' && y !== '2023-2024' && y !== '2022-2023' && y !== '2021-2022' && y !== '2020-2021' && y !== '2019-2020'">
                      <router-link :to="{ name: 'EcoloDefiSinglePage', params: { year: y } }"
                                   v-if="parseInt(y.substring(0, 4)) >= 2014">
                        Photos {{ y }}
                      </router-link>
                    </template>
                  </td>
                </tr>
              </table>
            </template>
          </table>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import _ from 'lodash';
  import ActivityRegistrationModal from '../../components/Activites/Activite_Inscription';

  export default {
    name: 'EcoloDefi',
    data() {
      return {
        years: [
          '2023-2024-Facebook',
          '2023-2024',
          '2022-2023',
          '2021-2022',
          '2020-2021',
          '2019-2020',
          '2018-2019',
          '2017-2018',
          '2016-2017',
          '2015-2016',
          '2014-2015',
          '2013-2014',
          '2012-2013',
          '2011-2012'
        ]
      };
    },
    async mounted() {
      await this.fetchActivities();
    },
    computed: {
      ...mapGetters('services', {
        _activities: 'activities'
      }),
      ...mapGetters({
        isConnected: 'account/isConnected'
      }),
      activity() {
        // Return the enabled avicourse
        let activities = this._activities;
        if (!activities) {
          return activities;
        }
        activities = _.sortBy(activities, a => a.date);
        if (_.isNumber(this.limit)) {
          activities = _.slice(activities, 0, this.limit);
        }
        return _.find(
          activities,
          a => a.type === 'ecolodefi' && a.acceptRegistrations === true
        );
      }
    },
    methods: {
      ...mapActions('services', {
        fetchActivities: 'fetchServices'
      }),
      async showRegisterModal() {
        // Ask the user to confirm and select the member to be registered.
        await this.$store.dispatch('members/fetchMembers');
        // Show modal
        this.$modal.show(
          ActivityRegistrationModal,
          { activityId: this.activity.id },
          {
            height: 'auto',
            minHeight: 300,
            name: 'activity-registration-modal',
            root: this.$root
          }
        );
      }
    }
  };
</script>

<style scoped>
p {
  margin-left: 0 !important;
}
</style>
